import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { FaArrowLeft, FaEye, FaCalendarAlt, FaPhone, FaEnvelope, FaGraduationCap, FaShoppingBag, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

function SchoolOrders() {
  const { schoolName } = useParams();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [schoolDetails, setSchoolDetails] = useState({});
  const [uniforms, setUniforms] = useState([]);

  useEffect(() => {
  console.log("Fetching orders for school:", schoolName);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/orders/school-orders/${schoolName}`);
      console.log("Orders response:", res.data);
      if (res.data.success) setOrders(res.data.orders);
    } catch (err) {
      console.error("Error fetching school orders:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchOrders();
}, [schoolName]);

  return (
    <div className="container-fluid p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      {/* Top Header */}
      <div className="d-flex align-items-center mb-4">
        <button 
          onClick={() => navigate(-1)} 
          className="btn btn-white shadow-sm rounded-pill px-4 me-3"
          style={{ border: "1px solid #dee2e6" }}
        >
          <FaArrowLeft className="me-2" /> Back
        </button>
        <h3 className="fw-bold mb-0 text-dark">School Overview</h3>
      </div>

      <div className="row g-4">
        {/* Left: School Profile Card */}
        <div className="col-lg-4">
          <div className="card border-0 shadow-sm p-4 text-center rounded-4">
            <div className="mx-auto mb-3 d-flex align-items-center justify-content-center bg-primary text-white rounded-circle" style={{ width: "80px", height: "80px", fontSize: "2rem" }}>
              <FaGraduationCap />
            </div>
            <h4 className="fw-bold mb-1">{schoolDetails.name || schoolName}</h4>
            <span className="badge bg-light text-primary mb-4 px-3 py-2 rounded-pill border border-primary">Official Partner</span>
            
            <div className="text-start mt-2">
              <div className="d-flex align-items-center mb-3 text-muted">
                <FaPhone className="me-3 text-primary" />
                <span>{schoolDetails.phone || "+91 XXXXX XXXXX"}</span>
              </div>
              <div className="d-flex align-items-center mb-3 text-muted">
                <FaEnvelope className="me-3 text-primary" />
                <span className="text-truncate">{schoolDetails.email || "school@edusupply.com"}</span>
              </div>
            </div>
            
            <hr className="my-4 opacity-50" />
            
            <div className="row">
              <div className="col-6">
                <p className="small text-muted mb-0">Total Orders</p>
                <h4 className="fw-bold">{orders.length}</h4>
              </div>
              <div className="col-6 border-start">
                <p className="small text-muted mb-0">Uniform Types</p>
                <h4 className="fw-bold">{uniforms.length}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Uniforms & Orders */}
        <div className="col-lg-8">
          {/* Uniforms Section */}
          <div className="card border-0 shadow-sm rounded-4 mb-4">
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-soft-primary p-2 rounded-3 me-3" style={{ backgroundColor: "#e7f1ff" }}>
                   <FaShoppingBag className="text-primary" />
                </div>
                <h5 className="fw-bold mb-0">Uniform Inventory</h5>
              </div>
              <div className="row g-2">
                {uniforms.length > 0 ? (
                  uniforms.map(u => (
                    <div key={u._id} className="col-md-6">
                      <div className="p-3 border rounded-3 d-flex justify-content-between align-items-center bg-light-subtle">
                        <span className="fw-semibold">{u.name}</span>
                        <span className="badge bg-dark">₹{u.price}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted small ps-2">No uniforms listed for this school.</p>
                )}
              </div>
            </div>
          </div>

          {/* Orders Section */}
          <h5 className="fw-bold mb-3 d-flex align-items-center">
            Recent Orders 
            <span className="badge bg-primary ms-2 rounded-pill fs-6">{orders.length}</span>
          </h5>

          {loading ? (
            <div className="text-center py-5 card border-0 shadow-sm rounded-4">
              <div className="spinner-border text-primary mb-3" role="status"></div>
              <p className="text-muted">Fetching school orders...</p>
            </div>
          ) : orders.length === 0 ? (
            <div className="alert alert-light border shadow-sm rounded-4 p-5 text-center">
              <FaExclamationCircle className="fs-1 text-warning mb-3" />
              <h5>No orders yet</h5>
              <p className="text-muted">Orders for this school will appear here once parents start purchasing.</p>
            </div>
          ) : (
            <div className="row g-3">
              {orders.map(order => (
                <div key={order._id} className="col-12">
                  <div className="card border-0 shadow-sm rounded-4 hover-shadow transition-all">
                    <div className="card-body p-3">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="d-flex align-items-center">
                            <div className="bg-light p-3 rounded-3 me-3">
                              📦
                            </div>
                            <div>
                              <h6 className="fw-bold mb-0">{order.parentName}</h6>
                              <small className="text-muted">ID: #{order._id.slice(-6).toUpperCase()}</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3 text-center">
                          <div className="fw-bold text-dark">₹{order.totalAmount}</div>
                          <div className="small text-muted">{order.items.length} Items</div>
                        </div>
                        <div className="col-md-4 d-flex justify-content-end align-items-center gap-2">
                          <span className={`badge rounded-pill px-3 py-2 ${order.paymentStatus === "Paid" ? "bg-success-subtle text-success" : "bg-danger-subtle text-danger"}`}>
                            {order.paymentStatus === "Paid" ? <FaCheckCircle className="me-1" /> : ""} {order.paymentStatus}
                          </span>
                          <button 
                            onClick={() => navigate(`/dashboard/order-details/${order._id}`)} 
                            className="btn btn-primary btn-sm rounded-pill px-3"
                          >
                            <FaEye className="me-1" /> View
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SchoolOrders;